import { render, staticRenderFns } from "./AddEditActions.vue?vue&type=template&id=8b074710&"
import script from "./AddEditActions.vue?vue&type=script&lang=js&"
export * from "./AddEditActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports